import axios from "axios";
import AuthContext from "./AuthContext";
import React, { createContext, useState, useContext } from "react";
import CompRenderingContext from "./CompRenderingContext";
const HomePageContext = createContext();

export const HomePageProvider = ({ children }) => {
  const isBrowser = typeof window !== "undefined";
  const LC_VIEWED_DATA = isBrowser
    ? JSON.parse(localStorage?.getItem("LC_VIEWED_DATA"))
    : null;

  const [homeInitialData, setHomeInitialData] = useState({
    isFetching: true,
    initialData: null,
    decorCategoriesList: [],
    addonCategoriesList: [],
  });

  const { locationData } = useContext(CompRenderingContext);
  const { user } = useContext(AuthContext);

  // useEffect(() => {
  //   !LC_VIEWED_DATA
  //     ? get_models_data()
  //     : user && updateViewedRecently(LC_VIEWED_DATA);
  //   get_models_data();
  //   // eslint-disable-next-line
  // }, []);

  const fetchHomeData = (params) => {
    const hubId = params?.hubId;

    !LC_VIEWED_DATA
      ? get_models_data({ hubId })
      : user && updateViewedRecently(LC_VIEWED_DATA);
    get_models_data({ hubId });
    // eslint-disable-next-line
  };

  const updateViewedRecently = async (LC_VIEWED_DATA) => {
    if (LC_VIEWED_DATA) {
      await add_to_recently_viewed(LC_VIEWED_DATA);
      window && localStorage.removeItem("LC_VIEWED_DATA");
      await get_models_data();
    }
  };

  const getDecorOccassionCategoryName = (code) => {
    return (
      homeInitialData.decorCategoriesList.filter(
        (curr) => parseInt(curr.code) === parseInt(code)
        // )[0]?.text || ""
      )[0]?.categoryName || ""
    );
  };

  const getAddonCategoryName = (code) => {
    return (
      homeInitialData.addonCategoriesList.filter(
        (curr) => parseInt(curr.code) === parseInt(code)
      )[0]?.text || ""
    
    );
  };
 

  const add_to_recently_viewed = async (LC_VIEWED_DATA) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/homepage/add_to_recently_viewed`,
        { data: LC_VIEWED_DATA },
        {
          headers: {
            Authorization: "Bearer " + user.token,
          },
        }
      );
    } catch (error) {
      console.log(error);
    }
  };

  const get_models_data = async (params) => {
    const hubId = params?.hubId;
    try {
      console.log(
        "hubid on get models data ",
        locationData?.selectedLocation?.hubId,
        "seosdfs",
        hubId
      );
      setHomeInitialData((prev) => ({
        isFetching: true,
        ...prev,
      }));
      console.log(locationData?.selectedLocation?.hubId)
      const { homePageBaseDataFetch } = await import(
        "../api/homePageCredentials/baseDataFetchApi"
      );

      const res = await homePageBaseDataFetch({
        hubId: hubId || locationData?.selectedLocation?.hubId,
      });
      setHomeInitialData({
        isFetching: false,
        initialData: res?.result,
        decorCategoriesList:
          res?.result?.miscInfos?.filter(
            // (curr) => curr.type === "_DECOR_OCCASSION_CATEGORY"
            (curr) => curr.type === "decorCategory"
          )[0]?.info || [],
        addonCategoriesList:
          res?.result?.miscInfos?.filter(
            // (curr) => curr.type === "_ADDON_CATEGORY"
            (curr) => curr.type === "addonCategory"
          )[0]?.info || [],
      });
    } catch (error) {
      console.log(error);
    }
  };
  const addToViewedRecently = async (productID) => {
    if (LC_VIEWED_DATA) {
      if (LC_VIEWED_DATA.includes(productID)) return;
      const LC_VIEWED_DATA_ = LC_VIEWED_DATA;
      LC_VIEWED_DATA_.push(productID);
      window &&
        localStorage.setItem("LC_VIEWED_DATA", JSON.stringify(LC_VIEWED_DATA_));
    } else {
      window &&
        localStorage.setItem("LC_VIEWED_DATA", JSON.stringify([productID]));
    }
  };

  return (
    <HomePageContext.Provider
      value={{
        addToViewedRecently,
        homeInitialData,
        getDecorOccassionCategoryName,
        getAddonCategoryName,
        fetchHomeData,
      }}
    >
      {children}
    </HomePageContext.Provider>
  );
};

export default HomePageContext;
